import { render, staticRenderFns } from "./channelCallBack.vue?vue&type=template&id=2e138b18&scoped=true&"
import script from "./channelCallBack.vue?vue&type=script&lang=js&"
export * from "./channelCallBack.vue?vue&type=script&lang=js&"
import style0 from "./channelCallBack.vue?vue&type=style&index=0&id=2e138b18&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e138b18",
  null
  
)

export default component.exports